import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { Cycle } from './Cycle';
import { CycleSet } from './CycleSet';

export class CycleResource extends FBaseService {
  public async getCycle(fiId: string, cycleId: number): Promise<Cycle> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/cycle/${cycleId}`,
    );

    const result: Cycle = response.data.data;
    return result;
  }

  public async getAllCycles(fiId: string): Promise<Cycle[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/cycle-set`,
    );

    const result: CycleSet[] = response.data.data;

    const cycles: Cycle[] = [];
    result.forEach((set: CycleSet) => {
      set.cyclesDesc.forEach((cycle: Cycle) => {
        cycles.push(cycle);
      });
    });
    return cycles;
  }


  public async getAllCyclesWithMonthEndDate(fiId: string): Promise<Cycle[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/cycle-set`,
    );

    const result: CycleSet[] = response.data.data;

    const cycles: Cycle[] = [];
    result.forEach((set: CycleSet) => {
      set.cyclesDesc.forEach((cycle: Cycle) => {
        if (!CycleResource.isStatementEndDateEndOfMonth(new Date(cycle.statementEndDate))) {
          const endOfMonthCycle: Cycle = {} as Cycle;
          const monthEndDate = CycleResource.getMonthEndDateFromStatementEnd(new Date(cycle.statementEndDate));
          endOfMonthCycle.endOfMonthDateInCycle = monthEndDate;

          cycles.push(endOfMonthCycle);
        }
        cycles.push(cycle);
      });
    });
    return cycles;
  }

  private static getMonthEndDateFromStatementEnd(statementEndDate: Date): string {
    const endOfMonthDate:Date = new Date(statementEndDate.getFullYear(), statementEndDate.getMonth() + 1, 0);

    return CycleResource.getDateStringForRequest(endOfMonthDate);
  }

  private static isStatementEndDateEndOfMonth(statementEndDate: Date): boolean {
    statementEndDate.setDate(statementEndDate.getDate() + 1);
    return statementEndDate.getUTCDate() === 1;
  }

  public async getActiveCycles(fiId: string): Promise<Cycle[]> {
    const today = CycleResource.getTodaysDate();
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/config/${fiId}/cycle/date/${today}`,
    );

    const result: Cycle[] = response.data.data;
    return result;
  }

  private static getTodaysDate(): string {
    const today = new Date();
    return CycleResource.getDateStringForRequest(today);
  }

  private static getDateStringForRequest(dateForRequest: Date): string {
    let dateString = `${dateForRequest.getFullYear()}-`;
    const month = dateForRequest.getMonth() + 1;
    if (month < 10) {
      dateString += `0${month}-`;
    } else {
      dateString += `${month}-`;
    }

    const date = dateForRequest.getDate();
    if (date < 10) {
      dateString += `0${date}`;
    } else {
      dateString += `${date}`;
    }

    return dateString;
  }
}

export default CycleResource;
